import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./pages/home/App";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import { initializeApm } from "./core/providers/apm.provider";
import { registerReauthInterceptor } from "./services/HttpInterceptor";

registerReauthInterceptor();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

initializeApm()
  .catch(() => {
    // Do not block app startup if APM fails to init.
  })
  .finally(() => {
    root.render(
      <BrowserRouter>
        <Provider store={store}>
          <App />
        </Provider>
      </BrowserRouter>
    );
  });
